import React, { SVGProps } from 'react';

type Props = {} & SVGProps<SVGSVGElement>;

export default function BackdatePCNsIcon(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? 24}
            height={props.height ?? 24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-cloud-backup-icon lucide-cloud-backup"
            {...props}
        >
            <path d="M21 15.251A4.5 4.5 0 0 0 17.5 8h-1.79A7 7 0 1 0 3 13.607" />
            <path d="M7 11v4h4" />
            <path d="M8 19a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5 4.82 4.82 0 0 0-3.41 1.41L7 15" />
        </svg>
    );
}
